import { render, staticRenderFns } from "./RestartView.vue?vue&type=template&id=09d00885"
import script from "./RestartView.vue?vue&type=script&lang=js"
export * from "./RestartView.vue?vue&type=script&lang=js"
import style0 from "./RestartView.vue?vue&type=style&index=0&id=09d00885&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports